import {
  DateTimeField,
  NumberField,
  RelationshipField,
  RelationshipFieldMany,
  StringField,
} from "../plugins/Cruxtify/field-types";
import {
  DateTimeProperty,
  NumberProperty,
  RelationshipProperty,
  RelationshipPropertyMany,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import { ApcCrudModel } from "./ApcCrudModel";

export class AttributeOption extends ApcCrudModel {
  public static icon = "mdi-tag";
  protected static _typeLabel = "Attribute Option";
  protected static asProperty = "attribute_option";
  public static api = {
    path: "attribute-options",
  };

  protected static routeBase = "attribute-options";

  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
      [UserRole.LoggedIn]: UserPermission.Read,
    },
    UserPermission.New
  );

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "deleted_at",
        label: "deleted At",
        userPermissions: UserPermission.Hidden,
        computed: true,
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "label",
        label: "Label",
        sortable: true,
        rules: ["required"],
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "attribute",
        label: "Attribute",
        relatedModel: "Attribute",
        foreignProperty: "attribute_options",
        rules: ["required"],
      },
    },
    {
      type: RelationshipPropertyMany,
      opts: {
        name: "products",
        label: "Products",
        relatedModel: "Product",
        foreignProperty: "attribute_options",
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    { type: DateTimeField, opts: { property: "created_at" } },
    { type: DateTimeField, opts: { property: "updated_at" } },
    { type: StringField, opts: { property: "label", isPrimaryLabelField: 1 } },
    { type: RelationshipField, opts: { property: "attribute" } },
    {
      type: RelationshipFieldMany,
      opts: {
        property: "products",
        viewComponentName: "form-relationship-field-many-table",
        formComponentName: "form-relationship-field-many-table",
      },
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["label", "attribute", "created_at"],
      enableSearch: true,
      enableDynamicFilters: true,
      useModal: true,
      dynamicFilterOptions: {
        filterFields: [
          "label",
          "attribute",
          "products",
          "created_at",
          "updated_at",
        ],
      },
      defaultSort: [
        {
          field: "label",
          order: "asc",
        },
      ],
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      type: "FieldSetGridLayout",
      opts: {
        id: "optionDetails",
        fieldSets: [
          {
            id: "main",
            fields: ["label", "attribute"],
          },
          {
            id: "products",
            fields: ["products"],
          },
          {
            id: "meta",
            fields: ["created_at", "updated_at", "id"],
          },
        ],
      },
    },
  ];
}
